import HomeOne from "./HomeOne";
import Vaults from "./Vaults";
import Contracts from "./Contracts";
import Stake from './Stake'
import TermsOfUse from './TermsOfUse'
import PrivacyPolicy from './PrivacyPolicy'
import Airdrop from './Airdrop'
import Dumpsters from './Dumpsters'
import WalletKit from './WalletKit'
import Presale from './Presale'
import SubmitForm from '../components/presale/submitForm'
import PrivatePoolParticipantForm from '../components/presale/submitPrivatePoolForm'
import PoolSubmissions from '../components/presale/poolSubmissions'
import PrivatePoolSubmissions from '../components/presale/privatePoolSubmissions'

const routes = [
  { path: '/', component: <HomeOne /> },
  { path: '/vaults', component: <Vaults /> },
  { path: '/stake', component: <Stake /> },
  { path: '/contracts', component: <Contracts /> },
  { path: '/terms-of-use', component: <TermsOfUse /> },
  { path: '/privacy-policy', component: <PrivacyPolicy /> },
  { path: '/airdrop', component: <Airdrop /> },
  { path: '/dumpsters/list', component: <Dumpsters /> },
  { path: '/wallet', component: <WalletKit /> },
  { path: '/presale', component: <Presale /> },
  { path: '/presale/submit', component: <SubmitForm /> },
  { path: '/presale/participate', component: <PrivatePoolParticipantForm /> },
  { path: '/presale/submissions', component: <PoolSubmissions /> },
  { path: '/presale/participants', component: <PrivatePoolSubmissions /> },
]

export default routes; 